import { render, staticRenderFns } from "./NextTrainings.vue?vue&type=template&id=530a3cf6&"
import script from "./NextTrainings.vue?vue&type=script&lang=js&"
export * from "./NextTrainings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports